import * as React from "react"
import { SelectSeeker } from "@ui-seeker/core"
import { useSignal } from "@preact/signals-react"


const HOUR_OPTIONS = Array.from({ length: 24 }, (_, i) => ({
    label: `${i}:00`,
    value: i
}))

export default function TimeSelect({ ...props }) {
    const hourValue = useSignal([]) // múltiple selección
    return (
        <SelectSeeker
            options={HOUR_OPTIONS}
            label="Select Hours"
            value={hourValue.value}
            onChange={e => hourValue.value = e.target.value}
            multiple
            {...props}
        />
    )
}
